(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5PNAd", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $43f82d5e2aec0813$export$6503ec6e8aabbaf; }, function (v) { return $43f82d5e2aec0813$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $43f82d5e2aec0813$export$f7ad0328861e2f03; }, function (v) { return $43f82d5e2aec0813$export$f7ad0328861e2f03 = v; });
var $43f82d5e2aec0813$export$6503ec6e8aabbaf;
var $43f82d5e2aec0813$export$f7ad0328861e2f03;
"use strict";
var $43f82d5e2aec0813$var$mapping = new Map();
function $43f82d5e2aec0813$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$43f82d5e2aec0813$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $43f82d5e2aec0813$var$resolve(id) {
    var resolved = $43f82d5e2aec0813$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$43f82d5e2aec0813$export$6503ec6e8aabbaf = $43f82d5e2aec0813$var$register;
$43f82d5e2aec0813$export$f7ad0328861e2f03 = $43f82d5e2aec0813$var$resolve;

});

parcelRegister("1Wc5A", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $169495e45cbb2fb4$export$bdfd709ae4826697; }, function (v) { return $169495e45cbb2fb4$export$bdfd709ae4826697 = v; });
var $169495e45cbb2fb4$export$bdfd709ae4826697;
var $169495e45cbb2fb4$export$c9e73fbda7da57b6;
var $169495e45cbb2fb4$export$5a759dc7a1cfb72a;
"use strict";
var $169495e45cbb2fb4$var$bundleURL = {};
function $169495e45cbb2fb4$var$getBundleURLCached(id) {
    var value = $169495e45cbb2fb4$var$bundleURL[id];
    if (!value) {
        value = $169495e45cbb2fb4$var$getBundleURL();
        $169495e45cbb2fb4$var$bundleURL[id] = value;
    }
    return value;
}
function $169495e45cbb2fb4$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $169495e45cbb2fb4$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $169495e45cbb2fb4$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $169495e45cbb2fb4$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$169495e45cbb2fb4$export$bdfd709ae4826697 = $169495e45cbb2fb4$var$getBundleURLCached;
$169495e45cbb2fb4$export$c9e73fbda7da57b6 = $169495e45cbb2fb4$var$getBaseURL;
$169495e45cbb2fb4$export$5a759dc7a1cfb72a = $169495e45cbb2fb4$var$getOrigin;

});

parcelRegister("h3YPb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c6c1e5f2605d0f1b$export$581ff339ea0ba762; });

var $8vYwU = parcelRequire("8vYwU");
function $c6c1e5f2605d0f1b$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $8vYwU._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("8vYwU", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $63302bee5109597d$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $63302bee5109597d$export$1e71eb4bef00f6b0; });
function $63302bee5109597d$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("6DVoC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4d62e84221647d42$export$4fa2f4023c9cbda5; });
function $4d62e84221647d42$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4d62e84221647d42$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $4d62e84221647d42$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("fOe4G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $02f85cab05fcc528$export$7e4530ad35d3bb8; });

var $dliKA = parcelRequire("dliKA");
function $02f85cab05fcc528$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $dliKA._set_prototype_of)(subClass, superClass);
}

});

parcelRegister("lrvjq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f9c46893f259e841$export$8dd05c13f5255580; });

var $ck0GA = parcelRequire("ck0GA");

var $62B8c = parcelRequire("62B8c");

var $3UaIO = parcelRequire("3UaIO");
function $f9c46893f259e841$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $62B8c._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $ck0GA._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ck0GA._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $3UaIO._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("ck0GA", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $8f87e27c27b0fd68$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $8f87e27c27b0fd68$export$f09211a7d3c496a1; });
function $8f87e27c27b0fd68$export$f09211a7d3c496a1(o) {
    $8f87e27c27b0fd68$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8f87e27c27b0fd68$export$f09211a7d3c496a1(o);
}

});

parcelRegister("3UaIO", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $2d7eeb29cd5ed2e0$export$ef97c660ca164e52; });

var $aZBH5 = parcelRequire("aZBH5");

var $cZhbL = parcelRequire("cZhbL");
function $2d7eeb29cd5ed2e0$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $cZhbL._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $aZBH5._assert_this_initialized)(self);
}

});
parcelRegister("aZBH5", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $800cd719491888d6$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $800cd719491888d6$export$f3b8ed2e4a5d10b8; });
function $800cd719491888d6$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("75IZX", function(module, exports) {


module.exports = (parcelRequire("jwX0n"))((parcelRequire("5PNAd")).resolve("dekAk")).then(function() {
    return parcelRequire("K36ig");
});

});
parcelRegister("jwX0n", function(module, exports) {
"use strict";

var $6uKQ7 = parcelRequire("6uKQ7");
module.exports = $6uKQ7(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("6uKQ7", function(module, exports) {
"use strict";
var $4ba9e0cecc89848c$var$cachedBundles = {};
var $4ba9e0cecc89848c$var$cachedPreloads = {};
var $4ba9e0cecc89848c$var$cachedPrefetches = {};
function $4ba9e0cecc89848c$var$getCache(type) {
    switch(type){
        case "preload":
            return $4ba9e0cecc89848c$var$cachedPreloads;
        case "prefetch":
            return $4ba9e0cecc89848c$var$cachedPrefetches;
        default:
            return $4ba9e0cecc89848c$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $4ba9e0cecc89848c$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("7L6s7", function(module, exports) {


module.exports = (parcelRequire("jwX0n"))((parcelRequire("5PNAd")).resolve("gGJZv")).then(function() {
    return parcelRequire("3cbWD");
});

});

var $bde32a69b0c083ad$exports = {};


(parcelRequire("5PNAd")).register((parcelRequire("1Wc5A")).getBundleURL("hBmCB"), JSON.parse('["hBmCB","index.ede8e5d7.js","dekAk","build.0d1e5d03.js","gGJZv","cert.92c69759.js","kP01T","sw.js","3RYNq","index.93939d29.js"]'));


var $kpAJq = parcelRequire("kpAJq");

var $h3YPb = parcelRequire("h3YPb");

var $6DVoC = parcelRequire("6DVoC");

var $emxKn = parcelRequire("emxKn");

var $kD3Id = parcelRequire("kD3Id");

var $kpAJq = parcelRequire("kpAJq");

var $kyJin = parcelRequire("kyJin");

var $9Ptd6 = parcelRequire("9Ptd6");

var $8vYwU = parcelRequire("8vYwU");

var $fOe4G = parcelRequire("fOe4G");

var $lrvjq = parcelRequire("lrvjq");

var $emxKn = parcelRequire("emxKn");
var $53433c1cdfe24d51$var$STORE_KEY = Symbol("MixDB@@StoreKey");
var $53433c1cdfe24d51$export$e8bb24f7fbf8a7a1 = /*#__PURE__*/ function() {
    "use strict";
    function MixDB(name) {
        var version = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "1";
        (0, $kyJin._)(this, MixDB);
        this.name = name;
        this.version = version;
        this.connectors = [];
        this.stores = {};
    }
    (0, $9Ptd6._)(MixDB, [
        {
            key: "link",
            value: function link(connector) {
                this.connectors.push(connector);
                return this;
            }
        },
        {
            key: "store",
            value: function store(name, key) {
                this.stores[name] = {
                    [$53433c1cdfe24d51$var$STORE_KEY]: key
                };
                return this;
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $kpAJq._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, conn, e, _tmp, _tmp1, _i, store, data, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, obj, err;
                    return (0, $emxKn.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    12,
                                    13,
                                    14
                                ]);
                                _iterator = _this.connectors[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    11
                                ];
                                conn = _step.value;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    conn.init(_this)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                console.warn('MixDB: Error initializing connector "'.concat(conn.constructor.name, '", skipping'));
                                console.error(e);
                                conn.ready = false;
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                if (!conn.ready) return [
                                    3,
                                    10
                                ];
                                _tmp = [];
                                for(_tmp1 in _this.stores)_tmp.push(_tmp1);
                                _i = 0;
                                _state.label = 7;
                            case 7:
                                if (!(_i < _tmp.length)) return [
                                    3,
                                    10
                                ];
                                store = _tmp[_i];
                                return [
                                    4,
                                    conn.retrieve(store)
                                ];
                            case 8:
                                data = _state.sent();
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = data[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        obj = _step1.value;
                                        _this.put(store, obj, false);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                _state.label = 9;
                            case 9:
                                _i++;
                                return [
                                    3,
                                    7
                                ];
                            case 10:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 11:
                                return [
                                    3,
                                    14
                                ];
                            case 12:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "get",
            value: function get(store, key) {
                var _this = this;
                return (0, $kpAJq._)(function() {
                    return (0, $emxKn.__generator)(this, function(_state) {
                        store = _this.stores[store];
                        if (!store) throw "MixDB: Store not found";
                        return [
                            2,
                            store[key]
                        ];
                    });
                })();
            }
        },
        {
            key: "put",
            value: function put(storeName, obj) {
                var update = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var _this = this;
                return (0, $kpAJq._)(function() {
                    var store, keyName, key, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, conn, _tmp, e, err;
                    return (0, $emxKn.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                store = _this.stores[storeName];
                                if (!store) throw "MixDB: Store not found";
                                keyName = store[$53433c1cdfe24d51$var$STORE_KEY];
                                key = obj[keyName];
                                if (!key) throw 'MixDB: Object does not have key property "'.concat(keyName, '"');
                                if (!update) return [
                                    3,
                                    11
                                ];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = _this.connectors[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                conn = _step.value;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    6,
                                    ,
                                    7
                                ]);
                                _tmp = conn.ready;
                                if (!_tmp) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    conn.update(storeName, obj)
                                ];
                            case 4:
                                _tmp = _state.sent();
                                _state.label = 5;
                            case 5:
                                _tmp;
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                console.warn(e);
                                conn.ready = false // if error, invalidate the connector
                                ;
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                store[key] = obj;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAll",
            value: function getAll(store) {
                var _this = this;
                return (0, $kpAJq._)(function() {
                    return (0, $emxKn.__generator)(this, function(_state) {
                        store = _this.stores[store];
                        if (!store) throw "MixDB: Store not found";
                        return [
                            2,
                            Object.values(store)
                        ];
                    });
                })();
            }
        }
    ]);
    return MixDB;
}();
var $53433c1cdfe24d51$export$b2278035370d6017 = /*#__PURE__*/ function() {
    "use strict";
    function Connector() {
        (0, $kyJin._)(this, Connector);
        (0, $8vYwU._)(this, "ready", false);
    }
    (0, $9Ptd6._)(Connector, [
        {
            key: "init",
            value: function init() {
                return (0, $kpAJq._)(function() {
                    return (0, $emxKn.__generator)(this, function(_state) {
                        throw "not implemented";
                    });
                })();
            }
        },
        {
            key: "update",
            value: function update() {
                return (0, $kpAJq._)(function() {
                    return (0, $emxKn.__generator)(this, function(_state) {
                        throw "not implemented";
                    });
                })();
            }
        },
        {
            key: "retrieve",
            value: function retrieve() {
                return (0, $kpAJq._)(function() {
                    return (0, $emxKn.__generator)(this, function(_state) {
                        throw "not implemented";
                    });
                })();
            }
        }
    ]);
    return Connector;
}();
var $53433c1cdfe24d51$export$46faa601fddd7823 = /*#__PURE__*/ function(Connector) {
    "use strict";
    (0, $fOe4G._)(IDBConnector, Connector);
    var _super = (0, $lrvjq._)(IDBConnector);
    function IDBConnector(openFn) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $kyJin._)(this, IDBConnector);
        var _this;
        _this = _super.call(this);
        _this.openFn = openFn;
        _this.opts = opts;
        return _this;
    }
    (0, $9Ptd6._)(IDBConnector, [
        {
            key: "init",
            value: function init(db) {
                var _this = this;
                return (0, $kpAJq._)(function() {
                    return (0, $emxKn.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.db = db;
                                return [
                                    4,
                                    _this.openFn(db.name, db.version, _this.opts)
                                ];
                            case 1:
                                _this.idb = _state.sent();
                                _this.ready = true;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "retrieve",
            value: function retrieve(storeName) {
                var _this_idb;
                return (_this_idb = this.idb) === null || _this_idb === void 0 ? void 0 : _this_idb.getAll(storeName);
            }
        },
        {
            key: "update",
            value: function update(storeName, obj) {
                var _this_idb;
                return (_this_idb = this.idb) === null || _this_idb === void 0 ? void 0 : _this_idb.put(storeName, obj);
            }
        }
    ]);
    return IDBConnector;
}($53433c1cdfe24d51$export$b2278035370d6017);
var $53433c1cdfe24d51$export$c2f8e5bb79ad5b2c = /*#__PURE__*/ function(Connector) {
    "use strict";
    (0, $fOe4G._)(StorageConnector, Connector);
    var _super = (0, $lrvjq._)(StorageConnector);
    function StorageConnector(storage) {
        (0, $kyJin._)(this, StorageConnector);
        var _this;
        _this = _super.call(this);
        _this.storage = storage;
        return _this;
    }
    (0, $9Ptd6._)(StorageConnector, [
        {
            key: "init",
            value: function init(db) {
                var _this = this;
                return (0, $kpAJq._)(function() {
                    return (0, $emxKn.__generator)(this, function(_state) {
                        _this.db = db;
                        _this.ready = true;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "retrieve",
            value: function retrieve(storeName) {
                var _this = this;
                return (0, $kpAJq._)(function() {
                    var store, json;
                    return (0, $emxKn.__generator)(this, function(_state) {
                        store = _this.db.stores[storeName];
                        if (!store) throw "MixDB Connector: Store not found";
                        json = _this.storage.getItem("mixdb_".concat(_this.db.name, "_").concat(storeName)) || "[]";
                        return [
                            2,
                            JSON.parse(json)
                        ];
                    });
                })();
            }
        },
        {
            key: "update",
            value: function update(storeName) {
                var _this = this;
                return (0, $kpAJq._)(function() {
                    var store;
                    return (0, $emxKn.__generator)(this, function(_state) {
                        store = _this.db.stores[storeName];
                        if (!store) throw "MixDB Connector: Store not found";
                        // have to update the whole thing smh
                        _this.storage.setItem("mixdb_".concat(_this.db.name, "_").concat(storeName), JSON.stringify(Object.values(store)));
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return StorageConnector;
}($53433c1cdfe24d51$export$b2278035370d6017);


// use a MixDB to increase stability and reliability
// link an idb connector and fallback to localStorage
// if both fail, in-memory storage is used
var $86609435a27b9d1d$var$db = new (0, $53433c1cdfe24d51$export$e8bb24f7fbf8a7a1)("pwastore", "200").store("sources", "id").link(new (0, $53433c1cdfe24d51$export$c2f8e5bb79ad5b2c)(localStorage));

if (typeof Proxy === "function") (parcelRequire("75IZX")).then(function(param) {
    var openDB = param.openDB;
    $86609435a27b9d1d$var$db.link(new (0, $53433c1cdfe24d51$export$46faa601fddd7823)(openDB, {
        upgrade: function(db) {
            try {
                db.createObjectStore("sources", {
                    keyPath: "id",
                    autoIncrement: false
                });
            } catch (e) {
                console.warn(e);
            }
        }
    }));
});
var $86609435a27b9d1d$var$matchSearch = function(pwa, search) {
    search = search.toLowerCase();
    return search.includes(pwa.name.toLowerCase()) || pwa.name.toLowerCase().includes(search) || search.includes(pwa.description.toLowerCase()) || pwa.description.toLowerCase().includes(search) || pwa.id.toLowerCase() == search;
};
var $86609435a27b9d1d$var$buildAppProfile = function() {
    var _ref = (0, $kpAJq._)(function(source, pwa) {
        var p, _, _tmp;
        return (0, $emxKn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    p = new (0, $kD3Id.Profile)(source.id + "." + pwa.id, pwa.name, pwa.description, 1, "PWA Store v".concat((0, $kD3Id.VERSION)), (0, $kD3Id.AppleUUID)());
                    _ = p.webClip;
                    _tmp = [
                        pwa.name,
                        pwa.url
                    ];
                    return [
                        4,
                        (0, $kD3Id.fetchIcon)(pwa.icon)
                    ];
                case 1:
                    _.apply(p, _tmp.concat([
                        _state.sent(),
                        1,
                        (0, $kD3Id.AppleUUID)()
                    ]));
                    return [
                        2,
                        p
                    ];
            }
        });
    });
    return function buildAppProfile(source, pwa) {
        return _ref.apply(this, arguments);
    };
}();

var $86609435a27b9d1d$var$downloadProfile = function() {
    var _ref = (0, $kpAJq._)(function(source, pwa) {
        var _tmp, hexkeymat, hexserial, strexpiry, keymat, serial, expiry, signProfile, blob, _tmp1;
        return (0, $emxKn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(typeof BigInt !== "function")) return [
                        3,
                        2
                    ];
                    _tmp = [
                        pwa.id + ".pwastore.mobileconfig"
                    ];
                    return [
                        4,
                        $86609435a27b9d1d$var$buildAppProfile(source, pwa)
                    ];
                case 1:
                    return [
                        2,
                        (0, $kD3Id.download).apply(void 0, _tmp.concat([
                            _state.sent().url()
                        ]))
                    ];
                case 2:
                    hexkeymat = localStorage.getItem("pwastore_keymat");
                    hexserial = localStorage.getItem("pwastore_serial");
                    strexpiry = localStorage.getItem("pwastore_expiry");
                    if (hexkeymat && pwa.id == "storefront") {
                        pwa.url += "?k=" + hexkeymat;
                        pwa.url += "&s=" + hexserial;
                        pwa.url += "?e=" + strexpiry;
                    }
                    if (!(!!localStorage.getItem("pwastore_signedprofile") && hexkeymat && hexserial && strexpiry)) return [
                        3,
                        6
                    ];
                    keymat = Uint8Array.from(hexkeymat.match(/.{1,2}/g).map(function(byte) {
                        return parseInt(byte, 16);
                    }));
                    serial = Uint8Array.from(hexserial.match(/.{1,2}/g).map(function(byte) {
                        return parseInt(byte, 16);
                    }));
                    expiry = parseInt(strexpiry);
                    return [
                        4,
                        (parcelRequire("7L6s7"))
                    ];
                case 3:
                    signProfile = _state.sent().signProfile;
                    return [
                        4,
                        $86609435a27b9d1d$var$buildAppProfile(source, pwa)
                    ];
                case 4:
                    return [
                        4,
                        signProfile.apply(void 0, [
                            _state.sent(),
                            keymat,
                            serial,
                            expiry,
                            pwa.id == "storefront"
                        ])
                    ];
                case 5:
                    blob = _state.sent();
                    return [
                        2,
                        (0, $kD3Id.download)(pwa.id + ".pwastore.mobileconfig", URL.createObjectURL(blob))
                    ];
                case 6:
                    _tmp1 = [
                        pwa.id + ".pwastore.mobileconfig"
                    ];
                    return [
                        4,
                        $86609435a27b9d1d$var$buildAppProfile(source, pwa)
                    ];
                case 7:
                    return [
                        2,
                        (0, $kD3Id.download).apply(void 0, _tmp1.concat([
                            _state.sent().url()
                        ]))
                    ];
            }
        });
    });
    return function downloadProfile(source, pwa) {
        return _ref.apply(this, arguments);
    };
}();
var $86609435a27b9d1d$var$renderPWA = function(div, src, pwa) {
    var _pwa_icon;
    var cnt = div;
    if (!("_pwa" in div)) {
        cnt = document.createElement("div");
        cnt.addEventListener("click", function() {
            return $86609435a27b9d1d$var$route("?app=".concat(encodeURIComponent(pwa.id), "&source=").concat(encodeURIComponent(src.id)));
        });
        div.appendChild(cnt);
    }
    cnt.classList.add("list-item");
    cnt.innerHTML = '\n    <img style="cursor:pointer" class="appimg" src="'.concat((_pwa_icon = pwa.icon) === null || _pwa_icon === void 0 ? void 0 : _pwa_icon.replace(/"/g, ""), '" width="64" height="64" alt="" onerror="this.src=\'thirdparty/notfound.png\'">\n    <div class="list-item-desc">\n      <span style="cursor:pointer">').concat((0, $kD3Id.escape)(pwa.name), '</span><br>\n      <small class="text-faded" style="cursor:pointer">').concat((0, $kD3Id.escape)(pwa.short || src.name), "</small><br>\n    </div>");
};
var $86609435a27b9d1d$var$renderList = function(el, src, pwa) {
    var div = document.createElement("div");
    div.classList.add("explorelist-discv-item");
    $86609435a27b9d1d$var$renderPWA(div, src, pwa);
    div.dataset.id = "".concat(src.id, ".").concat(pwa.id);
    el.appendChild(div);
    return div;
};
var $86609435a27b9d1d$var$browseRoute = function() {
    var _ref = (0, $kpAJq._)(function(params) {
        var elems, query, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, el, visible;
        return (0, $emxKn.__generator)(this, function(_state) {
            $("#explore").style.display = "";
            elems = document.querySelectorAll(".explorelist-discv-item");
            query = params.get("search");
            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(_iterator = elems[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    el = _step.value;
                    visible = !query || $86609435a27b9d1d$var$matchSearch(el._pwa, query);
                    el.style.display = visible ? "" : "none";
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                2
            ];
        });
    });
    return function browseRoute(params) {
        return _ref.apply(this, arguments);
    };
}();
var $86609435a27b9d1d$var$setupBrowse = function() {
    var _ref = (0, $kpAJq._)(function() {
        var _$, el, hasLoaded, srcs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, src;
        function renderSource(src) {
            return _renderSource.apply(this, arguments);
        }
        function _renderSource() {
            _renderSource = (0, $kpAJq._)(function(src) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pwa, eel, item;
                return (0, $emxKn.__generator)(this, function(_state) {
                    if (!hasLoaded) {
                        hasLoaded = true;
                        el.innerHTML = "";
                    }
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = src.pwas[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            pwa = _step.value;
                            eel = $(".explorelist-discv-item[data-id='".concat(src.id, ".").concat(pwa.id, "']"));
                            if (eel) {
                                if (JSON.stringify(eel._pwa) != JSON.stringify(pwa)) $86609435a27b9d1d$var$renderPWA(eel, src, pwa);
                                eel._pwa = pwa;
                                eel._source = src;
                            } else {
                                item = $86609435a27b9d1d$var$renderList(el, src, pwa);
                                item._pwa = pwa;
                                item._source = src;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        2
                    ];
                });
            });
            return _renderSource.apply(this, arguments);
        }
        return (0, $emxKn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    el = $("#explore-content");
                    hasLoaded = false;
                    return [
                        4,
                        $86609435a27b9d1d$var$db.getAll("sources")
                    ];
                case 1:
                    srcs = _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = srcs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            src = _step.value;
                            if (src.cache) renderSource(src.cache);
                            else fetch(src.url).then(function(x) {
                                return x.json();
                            }).then(renderSource);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (srcs.length < 1) el.innerHTML = '<span id="explorelist-noitems">Seems like there\'s no apps here. Try refreshing your sources or relaunching the app.</span>';
                    else (_$ = $("#explorelist-noitems")) === null || _$ === void 0 ? void 0 : _$.remove();
                    return [
                        2
                    ];
            }
        });
    });
    return function setupBrowse() {
        return _ref.apply(this, arguments);
    };
}();
var $86609435a27b9d1d$var$appRoute = function() {
    var _ref = (0, $kpAJq._)(function(params) {
        var src, source, _tmp, pwa, install, _pwa_short, i;
        return (0, $emxKn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $("#app").style.display = "";
                    $("#app").classList.add("app-view-show");
                    $("#app-warning").style.display = "none";
                    $("#app-item-container").style.display = "none";
                    $("#app .app-customize-btn").style.display = localStorage.getItem("pwastore_customize") ? "" : "none";
                    if (!params.get("srcurl")) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        fetch(params.get("source"))
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    src = _state.sent();
                    src.cache = src;
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        $86609435a27b9d1d$var$db.get("sources", params.get("source"))
                    ];
                case 4:
                    src = _state.sent();
                    _state.label = 5;
                case 5:
                    if (!src) {
                        $("#app-warning").style.display = "";
                        $("#app-warning").textContent = "The app's source is not installed and could not be found. Please add the source first.";
                        return [
                            2
                        ];
                    }
                    _tmp = src.cache;
                    if (_tmp) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        fetch(src.url)
                    ];
                case 6:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 7:
                    _tmp = _state.sent();
                    _state.label = 8;
                case 8:
                    source = _tmp;
                    pwa = source.pwas.find(function(app) {
                        return app.id == params.get("app");
                    });
                    if (!pwa) {
                        $("#app-warning").style.display = "";
                        $("#app-warning").textContent = "The app could not be found in the source. It may have been deleted.";
                        return [
                            2
                        ];
                    }
                    install = function() {
                        var _ref = (0, $kpAJq._)(function() {
                            var _pwa_platform, ua, isAndroid;
                            return (0, $emxKn.__generator)(this, function(_state) {
                                ua = navigator.userAgent.toLowerCase();
                                isAndroid = ua.indexOf("android") > -1;
                                if (isAndroid) {
                                    if (((_pwa_platform = pwa.platform) === null || _pwa_platform === void 0 ? void 0 : _pwa_platform.indexOf("android")) >= 0 || confirm("This app is not supported on Android. Open anyway?")) window.open(pwa.url);
                                } else $86609435a27b9d1d$var$downloadProfile(source, pwa);
                                return [
                                    2
                                ];
                            });
                        });
                        return function install() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    if (pwa.url.trim().startsWith("j")) {
                        $("#app-warning").style.display = "";
                        $("#app-warning").textContent = "This app has been detected as malicious and cannot be viewed. If you think this is an error, report it to the app's source.";
                        return [
                            2
                        ];
                    }
                    $("#app-item-icon").src = pwa.icon || "a";
                    $("#app-item-title").textContent = pwa.name || "Unnamed App";
                    $("#app-item-short").textContent = (_pwa_short = pwa.short) !== null && _pwa_short !== void 0 ? _pwa_short : "";
                    $("#app-item-install").onclick = install;
                    $("#app-item-desc").textContent = pwa.description || "No description.";
                    $("#app-item-dev").style.display = pwa.dev ? "" : "none";
                    $("#app-item-funct").style.display = pwa.verified ? "none" : "";
                    $("#app-item-advanced-id").textContent = "".concat(source.id, ".").concat(pwa.id);
                    $("#app-item-advanced-source").textContent = source.name || source.id;
                    $("#app-item-advanced-url").href = pwa.url;
                    $("#app-item-advanced-url").textContent = pwa.url;
                    $("#app-item-advanced-license").textContent = pwa.license || "Proprietary";
                    $("#app-item-advanced-platform").textContent = (pwa.platform || [
                        "ios"
                    ]).map(function(p) {
                        if (p.toLowerCase() == "ios") return "iOS";
                        if (p.toLowerCase() == "ipados") return "iPadOS";
                        if (p.toLowerCase() == "macos") return "macOS";
                        return p[0].toUpperCase() + p.substring(1).toLowerCase();
                    }).join(", ");
                    $("#app-item-iap").style.display = pwa.iap && pwa.iap.length > 0 ? "" : "none";
                    if (pwa.iap && pwa.iap.length > 0) {
                        $("#app-item-iap-container").innerHTML = "";
                        for(i = 0; i < pwa.iap.length; i++){
                            $("#app-item-iap-container").appendChild($86609435a27b9d1d$var$mDiv().c("settings-row").cc([
                                $86609435a27b9d1d$var$mSpan().c("text-faded").t(pwa.iap[i].name),
                                $86609435a27b9d1d$var$mSpan().s("text-align:right").t(pwa.iap[i].price)
                            ]));
                            if (i < pwa.iap.length - 1) $("#app-item-iap-container").appendChild($86609435a27b9d1d$var$mEl("hr"));
                        }
                    }
                    $("#app-item-customize").onclick = /*#__PURE__*/ (0, $kpAJq._)(function() {
                        return (0, $emxKn.__generator)(this, function(_state) {
                            $("#customize").style.display = "";
                            $("body").style.overflowY = "hidden";
                            $("#customize").classList.remove("sheet-hide");
                            $("#customize").parentNode.children[0].style.display = "";
                            $("#customize").parentNode.children[0].classList.remove("sheet-hide");
                            $("#cstmz-icon").onclick = /*#__PURE__*/ (0, $kpAJq._)(function() {
                                var input;
                                return (0, $emxKn.__generator)(this, function(_state) {
                                    input = document.createElement("input");
                                    input.type = "file";
                                    input.accept = "image/png, image/jpeg, image/jpg";
                                    input.addEventListener("change", function() {
                                        if (input.files.length > 0) {
                                            var fr = new FileReader();
                                            fr.addEventListener("load", function() {
                                                $("#cstmz-icon").src = fr.result;
                                            });
                                            fr.readAsDataURL(input.files[0]);
                                        }
                                        console.log(input.files);
                                    });
                                    input.click();
                                    return [
                                        2
                                    ];
                                });
                            });
                            $("#cstmz-icon").src = pwa.icon || "a";
                            $("#cstmz-title").value = "";
                            $("#cstmz-title").placeholder = pwa.name || "Unnamed App";
                            $("#cstmz-btn").onclick = /*#__PURE__*/ (0, $kpAJq._)(function() {
                                return (0, $emxKn.__generator)(this, function(_state) {
                                    $86609435a27b9d1d$var$downloadProfile(source, (0, $6DVoC._)((0, $h3YPb._)({}, pwa), {
                                        name: $("#cstmz-title").value || $("#cstmz-title").placeholder,
                                        icon: $("#cstmz-icon").src || pwa.icon
                                    }));
                                    return [
                                        2
                                    ];
                                });
                            });
                            return [
                                2
                            ];
                        });
                    });
                    $("#app-item-container").style.display = "";
                    return [
                        2
                    ];
            }
        });
    });
    return function appRoute(params) {
        return _ref.apply(this, arguments);
    };
}();
var $86609435a27b9d1d$var$hideCustomize = function() {
    $("body").style.overflowY = "";
    $("#customize").classList.add("sheet-hide");
    $("#customize").parentNode.children[0].classList.add("sheet-hide");
    setTimeout(function() {
        return $("#customize").style.display = "none";
    }, 350);
};
var $86609435a27b9d1d$var$settingsRoute = function() {
    $("#settings").style.display = "";
};
var $86609435a27b9d1d$var$_debugspamcheck = 0;
var $86609435a27b9d1d$var$setupSettings = function() {
    $("#stg-debug").checked = !!localStorage.getItem("pwastore_debug");
    $("#stg-debug").addEventListener("change", function() {
        if ($86609435a27b9d1d$var$_debugspamcheck == 0) setTimeout(function() {
            if ($86609435a27b9d1d$var$_debugspamcheck > 5) {
                localStorage.setItem("pwastore_experiments", localStorage.getItem("pwastore_experiments") == "yes" ? "" : "yes");
                $("#stg-debug").parentElement.classList.add("switch-special");
                $("#stg-debug").checked = false;
                setTimeout(function() {
                    $("#stg-debug").parentElement.classList.remove("switch-special");
                    $("#stg-debug").checked = !!localStorage.getItem("pwastore_debug");
                    setTimeout(function() {
                        return location.href = "/";
                    }, 400);
                }, 400);
            }
            $86609435a27b9d1d$var$_debugspamcheck = 0;
        }, 1000);
        $86609435a27b9d1d$var$_debugspamcheck++;
        localStorage.setItem("pwastore_debug", $("#stg-debug").checked ? "yes" : "");
    });
    $("#stg-customize").checked = !!localStorage.getItem("pwastore_customize");
    $("#stg-customize").addEventListener("change", function() {
        localStorage.setItem("pwastore_customize", $("#stg-customize").checked ? "yes" : "");
    });
    $("#stg-autorefresh").checked = !!localStorage.getItem("pwastore_autorefresh");
    $("#stg-autorefresh").addEventListener("change", function() {
        localStorage.setItem("pwastore_autorefresh", $("#stg-autorefresh").checked ? "yes" : "");
    });
    $("#experiments").style.display = localStorage.getItem("pwastore_experiments") == "yes" ? "" : "none";
    $("#tab-themes").style.display = localStorage.getItem("pwastore_experiments") == "yes" ? "" : "none";
    $("#tab-myapps").style.display = localStorage.getItem("pwastore_experiments") == "yes" ? "" : "none";
    $("#stg-pwastore-ver").textContent = "v".concat((0, $kD3Id.VERSION), ' "').concat((0, $kD3Id.CODENAME), '"');
    $("#stg-pwastore-bdg").style.display = localStorage.getItem("pwastore_experiments") == "yes" ? "" : "none";
    $("#stg-signedprofile").checked = !!localStorage.getItem("pwastore_signedprofile");
    $("#stg-signedprofile").addEventListener("change", function() {
        localStorage.setItem("pwastore_signedprofile", $("#stg-signedprofile").checked ? "yes" : "");
    });
};
var $86609435a27b9d1d$var$refreshAllSources = function() {
    var _ref = (0, $kpAJq._)(function() {
        var srcs, i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, src, json, e, err;
        return (0, $emxKn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($("#src-refresh-btn").classList.contains("disabled")) return [
                        2
                    ];
                    $("#src-refresh-btn").classList.add("disabled");
                    $("#sources .bottom-progress").style.width = "0%";
                    $("#sources .bottom-progress").classList.remove("bottom-progress-done");
                    setTimeout(function() {
                        return $("#sources .bottom-progress").style.width = "25%";
                    }, 1);
                    return [
                        4,
                        new Promise(function(res) {
                            return setTimeout(res, 250);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        $86609435a27b9d1d$var$db.getAll("sources")
                    ];
                case 2:
                    srcs = _state.sent();
                    i = 0;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        14,
                        15,
                        16
                    ]);
                    _iterator = srcs[Symbol.iterator]();
                    _state.label = 4;
                case 4:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        13
                    ];
                    src = _step.value;
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        10,
                        11,
                        12
                    ]);
                    return [
                        4,
                        fetch(src.url)
                    ];
                case 6:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 7:
                    json = _state.sent();
                    return [
                        4,
                        $86609435a27b9d1d$var$db.put("sources", {
                            id: json.id,
                            icon: json.icon,
                            name: json.name,
                            url: src.url,
                            cache: json
                        })
                    ];
                case 8:
                    _state.sent();
                    return [
                        4,
                        new Promise(function(res) {
                            return setTimeout(res, 10);
                        })
                    ];
                case 9:
                    _state.sent();
                    return [
                        3,
                        12
                    ];
                case 10:
                    e = _state.sent();
                    console.error(e);
                    return [
                        3,
                        12
                    ];
                case 11:
                    i++;
                    $("#sources .bottom-progress").style.width = "".concat((25 + i / srcs.length * 65).toFixed(0), "%");
                    return [
                        7
                    ];
                case 12:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        4
                    ];
                case 13:
                    return [
                        3,
                        16
                    ];
                case 14:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 15:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        4,
                        new Promise(function(res) {
                            return setTimeout(res, 250);
                        })
                    ];
                case 17:
                    _state.sent();
                    $("#sources .bottom-progress").style.width = "100%";
                    setTimeout(function() {
                        return $("#sources .bottom-progress").classList.add("bottom-progress-done");
                    }, 350);
                    setTimeout(function() {
                        return $("#sources .bottom-progress").style.width = "0%";
                    }, 700);
                    $("#src-refresh-btn").classList.remove("disabled");
                    $86609435a27b9d1d$var$setupBrowse() // fully reload the app list
                    ;
                    return [
                        2
                    ];
            }
        });
    });
    return function refreshAllSources() {
        return _ref.apply(this, arguments);
    };
}();
var $86609435a27b9d1d$var$addSource = function() {
    var _ref = (0, $kpAJq._)(function(src) {
        var json;
        return (0, $emxKn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(0, $kD3Id.isurl)(src)) return [
                        2
                    ];
                    return [
                        4,
                        fetch(src)
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    json = _state.sent();
                    if (!(json && json.id && json.name && json.pwas)) return [
                        3,
                        4
                    ];
                    if (!confirm('Would you like to add the source "'.concat(json.name, '"?'))) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $86609435a27b9d1d$var$db.put("sources", {
                            id: json.id,
                            icon: json.icon,
                            name: json.name,
                            url: src,
                            cache: json
                        })
                    ];
                case 3:
                    _state.sent();
                    $86609435a27b9d1d$var$setupBrowse() // fully reload the app list
                    ;
                    $86609435a27b9d1d$var$reloadSources();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function addSource(src) {
        return _ref.apply(this, arguments);
    };
}();
var $86609435a27b9d1d$var$deleteSource = function() {
    var _ref = (0, $kpAJq._)(function(srcid) {
        return (0, $emxKn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!confirm("Are you sure you want to delete this source?")) return [
                        2
                    ];
                    return [
                        4,
                        $86609435a27b9d1d$var$db.delete("sources", srcid)
                    ];
                case 1:
                    _state.sent();
                    $86609435a27b9d1d$var$setupBrowse() // fully reload the app list
                    ;
                    $86609435a27b9d1d$var$reloadSources();
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteSource(srcid) {
        return _ref.apply(this, arguments);
    };
}();
var $86609435a27b9d1d$var$hideSources = function() {
    $("body").style.overflowY = "";
    $("#sources").classList.add("sheet-hide");
    $("#sources").parentNode.children[0].classList.add("sheet-hide");
    setTimeout(function() {
        return $("#sources").style.display = "none";
    }, 350);
    history.pushState(null, null, "?");
};
// microElements
var $86609435a27b9d1d$var$mEl = function(t, id) {
    var e = document.createElement(t);
    if (id) e.id = id;
    e.c = function(cl) {
        e.classList.add(cl);
        return e;
    };
    e.t = function(t) {
        e.textContent = t;
        return e;
    };
    e.h = function(h) {
        e.innerHTML = h;
        return e;
    };
    e.a = function(a, v) {
        e[a] = v;
        return e;
    };
    e.o = function(n, h) {
        e.addEventListener(n, h);
        return e;
    };
    e.cc = function(cs) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = cs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                e.appendChild(c);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return e;
    };
    e.s = function(s) {
        e["style"] = s;
        return e;
    };
    return e;
};
var $86609435a27b9d1d$var$mDiv = function(id) {
    return $86609435a27b9d1d$var$mEl("div", id);
};
var $86609435a27b9d1d$var$mImg = function(id) {
    return $86609435a27b9d1d$var$mEl("img", id);
};
var $86609435a27b9d1d$var$mBr = function(id) {
    return $86609435a27b9d1d$var$mEl("br", id);
};
var $86609435a27b9d1d$var$mSpan = function(id) {
    return $86609435a27b9d1d$var$mEl("span", id);
};
var $86609435a27b9d1d$var$reloadSources = function() {
    var _ref = (0, $kpAJq._)(function() {
        var srcs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
        return (0, $emxKn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $86609435a27b9d1d$var$db.getAll("sources")
                    ];
                case 1:
                    srcs = _state.sent();
                    $("#srcs-list").innerHTML = "";
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        _loop = function() {
                            var src = _step.value;
                            $("#srcs-list").appendChild($86609435a27b9d1d$var$mDiv().c("list-item").cc([
                                $86609435a27b9d1d$var$mImg().c("appimg").a("src", src.icon).a("alt", "").a("width", "64").a("height", "64"),
                                $86609435a27b9d1d$var$mDiv().c("list-item-desc").s("width:100%").cc([
                                    $86609435a27b9d1d$var$mSpan().t(src.name),
                                    $86609435a27b9d1d$var$mBr(),
                                    $86609435a27b9d1d$var$mSpan().s("margin-top:-1.4rem;float:right;cursor:pointer;color:#FF453A").o("click", function() {
                                        return $86609435a27b9d1d$var$deleteSource(src.id);
                                    }).h('<svg width="19.2676" height="23.4863" fill="currentColor"><path d="M6.5625 18.6035C6.93359 18.6035 7.17773 18.3691 7.16797 18.0273L6.86523 7.57812C6.85547 7.23633 6.61133 7.01172 6.25977 7.01172C5.88867 7.01172 5.64453 7.24609 5.6543 7.58789L5.94727 18.0273C5.95703 18.3789 6.20117 18.6035 6.5625 18.6035ZM9.45312 18.6035C9.82422 18.6035 10.0879 18.3691 10.0879 18.0273L10.0879 7.58789C10.0879 7.24609 9.82422 7.01172 9.45312 7.01172C9.08203 7.01172 8.82812 7.24609 8.82812 7.58789L8.82812 18.0273C8.82812 18.3691 9.08203 18.6035 9.45312 18.6035ZM12.3535 18.6035C12.7051 18.6035 12.9492 18.3789 12.959 18.0273L13.252 7.58789C13.2617 7.24609 13.0176 7.01172 12.6465 7.01172C12.2949 7.01172 12.0508 7.23633 12.041 7.58789L11.748 18.0273C11.7383 18.3691 11.9824 18.6035 12.3535 18.6035ZM5.16602 4.46289L6.71875 4.46289L6.71875 2.37305C6.71875 1.81641 7.10938 1.45508 7.69531 1.45508L11.1914 1.45508C11.7773 1.45508 12.168 1.81641 12.168 2.37305L12.168 4.46289L13.7207 4.46289L13.7207 2.27539C13.7207 0.859375 12.8027 0 11.2988 0L7.58789 0C6.08398 0 5.16602 0.859375 5.16602 2.27539ZM0.732422 5.24414L18.1836 5.24414C18.584 5.24414 18.9062 4.90234 18.9062 4.50195C18.9062 4.10156 18.584 3.76953 18.1836 3.76953L0.732422 3.76953C0.341797 3.76953 0 4.10156 0 4.50195C0 4.91211 0.341797 5.24414 0.732422 5.24414ZM4.98047 21.748L13.9355 21.748C15.332 21.748 16.2695 20.8398 16.3379 19.4434L17.0215 5.05859L15.4492 5.05859L14.7949 19.2773C14.7754 19.8633 14.3555 20.2734 13.7793 20.2734L5.11719 20.2734C4.56055 20.2734 4.14062 19.8535 4.11133 19.2773L3.41797 5.05859L1.88477 5.05859L2.57812 19.4531C2.64648 20.8496 3.56445 21.748 4.98047 21.748Z"/></svg>')
                                ])
                            ]));
                        };
                        for(_iterator = srcs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function reloadSources() {
        return _ref.apply(this, arguments);
    };
}();
var $86609435a27b9d1d$var$sourcesRoute = function() {
    var _ref = (0, $kpAJq._)(function(params) {
        return (0, $emxKn.__generator)(this, function(_state) {
            $("#sources").style.display = "";
            $("body").style.overflowY = "hidden";
            $("#sources").classList.remove("sheet-hide");
            $("#sources").parentNode.children[0].style.display = "";
            $("#sources").parentNode.children[0].classList.remove("sheet-hide");
            $86609435a27b9d1d$var$reloadSources();
            if (params.get("add")) $86609435a27b9d1d$var$addSource(decodeURIComponent(params.get("add")));
            return [
                2
            ];
        });
    });
    return function sourcesRoute(params) {
        return _ref.apply(this, arguments);
    };
}();
var $86609435a27b9d1d$var$searchAutoTimeout = -1;
var $86609435a27b9d1d$var$doSearch = function() {
    if ($86609435a27b9d1d$var$searchAutoTimeout >= 0) clearTimeout($86609435a27b9d1d$var$searchAutoTimeout);
    var search = $("#searchbox").value;
    if (search.trim() == "") return $86609435a27b9d1d$var$route("?");
    $86609435a27b9d1d$var$route("?search=" + encodeURIComponent(search));
};
$("#searchform").addEventListener("submit", function() {
    var _ref = (0, $kpAJq._)(function(ev) {
        return (0, $emxKn.__generator)(this, function(_state) {
            ev.preventDefault();
            $86609435a27b9d1d$var$doSearch();
            return [
                2
            ];
        });
    });
    return function(ev) {
        return _ref.apply(this, arguments);
    };
}());
$("#searchbox").addEventListener("input", function() {
    if ($86609435a27b9d1d$var$searchAutoTimeout >= 0) clearTimeout($86609435a27b9d1d$var$searchAutoTimeout);
    $86609435a27b9d1d$var$searchAutoTimeout = setTimeout($86609435a27b9d1d$var$doSearch, 100);
});
var $480f20022975eb24$exports = {};

$480f20022975eb24$exports = (parcelRequire("1Wc5A")).getBundleURL("hBmCB") + "sw.js";


if ("serviceWorker" in navigator) navigator.serviceWorker.register($480f20022975eb24$exports);
var $86609435a27b9d1d$var$route = function(uri) {
    history.pushState(null, null, uri);
    $86609435a27b9d1d$var$doroute(new URLSearchParams(uri));
};
var $86609435a27b9d1d$var$updateCertParams = function() {
    var params = new URLSearchParams(location.search);
    var hexkeymat = params.get("k");
    if (hexkeymat) localStorage.setItem("pwastore_keymat", hexkeymat);
    var hexserial = params.get("s");
    if (hexserial) localStorage.setItem("pwastore_serial", hexserial);
    var strexpiry = params.get("e");
    if (strexpiry) localStorage.setItem("pwastore_expiry", strexpiry);
    if (hexkeymat && hexserial && strexpiry) localStorage.setItem("pwastore_signedprofile", "yes");
};
window.addEventListener("load", /*#__PURE__*/ (0, $kpAJq._)(function() {
    var portrait, aspect;
    return (0, $emxKn.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                // initialize MixDB
                return [
                    4,
                    $86609435a27b9d1d$var$db.init()
                ];
            case 1:
                _state.sent();
                // make sure the cert params are stored in localStorage
                // TODO this should use MixDB too in case of quota limit
                $86609435a27b9d1d$var$updateCertParams();
                return [
                    4,
                    $86609435a27b9d1d$var$setupBrowse()
                ];
            case 2:
                _state.sent();
                $86609435a27b9d1d$var$setupSettings();
                if (localStorage.getItem("pwastore_autorefresh")) $86609435a27b9d1d$var$refreshAllSources();
                else if (localStorage.getItem("pwastore_version") != (0, $kD3Id.VERSION)) {
                    localStorage.setItem("pwastore_version", (0, $kD3Id.VERSION));
                    $86609435a27b9d1d$var$refreshAllSources();
                }
                if (!localStorage.getItem("pwastore_firsttime")) {
                    //route('?')
                    localStorage.setItem("pwastore_firsttime", true);
                    $("#first-time-dialog").style.display = "";
                    $("#ftd-done-btn").addEventListener("click", function() {
                        return $("#first-time-dialog").style.display = "none";
                    });
                }
                $("#tab-explore").addEventListener("click", function() {
                    return $86609435a27b9d1d$var$route("?");
                });
                $("#tab-settings").addEventListener("click", function() {
                    return $86609435a27b9d1d$var$route("?settings=1");
                });
                $("#app-back-btn").addEventListener("click", function() {
                    return $86609435a27b9d1d$var$route("?");
                });
                $("#cstmz-done-btn").addEventListener("click", $86609435a27b9d1d$var$hideCustomize);
                $("#srcs-open-btn").addEventListener("click", function() {
                    return $86609435a27b9d1d$var$route("?sources=1");
                });
                $("#srcs-done-btn").addEventListener("click", $86609435a27b9d1d$var$hideSources);
                $("#srcs-add-btn").addEventListener("click", function() {
                    return $86609435a27b9d1d$var$addSource(prompt("Add Source from URL"));
                });
                $("#src-refresh-btn").addEventListener("click", $86609435a27b9d1d$var$refreshAllSources);
                portrait = window.innerHeight > window.innerWidth;
                aspect = portrait ? window.innerHeight / window.innerWidth : window.innerWidth / window.innerHeight;
                // 16:9 vs 19.5:9
                if (aspect > 17 / 9) $(".tabs").style.paddingBottom = "1rem";
                $86609435a27b9d1d$var$doroute(new URLSearchParams(location.search));
                return [
                    2
                ];
        }
    });
}));
var $86609435a27b9d1d$var$doroute = function() {
    var _ref = (0, $kpAJq._)(function(params) {
        var updateDOM;
        return (0, $emxKn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    updateDOM = function() {
                        var _ref = (0, $kpAJq._)(function() {
                            var json;
                            return (0, $emxKn.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        $("#tab-explore").classList.add("tab-selected");
                                        $("#tab-settings").classList.remove("tab-selected");
                                        return [
                                            4,
                                            $86609435a27b9d1d$var$db.getAll("sources")
                                        ];
                                    case 1:
                                        if (!(_state.sent().length < 1)) return [
                                            3,
                                            5
                                        ];
                                        return [
                                            4,
                                            fetch(location.origin + "/core.json")
                                        ];
                                    case 2:
                                        return [
                                            4,
                                            _state.sent().json()
                                        ];
                                    case 3:
                                        json = _state.sent();
                                        return [
                                            4,
                                            $86609435a27b9d1d$var$db.put("sources", {
                                                id: "app.pwastore.core",
                                                icon: "/thirdparty/pwastore.png",
                                                name: "PWAStore Core",
                                                url: location.origin + "/core.json",
                                                cache: json
                                            })
                                        ];
                                    case 4:
                                        _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        if (params.get("app")) {
                                            $("#explore").style.display = "none";
                                            $("#settings").style.display = "none";
                                            $86609435a27b9d1d$var$appRoute(params);
                                        } else if (params.get("settings")) {
                                            $86609435a27b9d1d$var$settingsRoute(params);
                                            $("#explore").style.display = "none";
                                            $("#app").style.display = "none";
                                            $("#tab-explore").classList.remove("tab-selected");
                                            $("#tab-settings").classList.add("tab-selected");
                                        } else if (params.get("sources")) {
                                            $("#app").style.display = "none";
                                            $("#settings").style.display = "none";
                                            $86609435a27b9d1d$var$browseRoute(params);
                                            $86609435a27b9d1d$var$sourcesRoute(params);
                                        } else {
                                            $("#app").style.display = "none";
                                            $("#settings").style.display = "none";
                                            $86609435a27b9d1d$var$browseRoute(params);
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function updateDOM() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    if (!("startViewTransition" in document)) return [
                        3,
                        1
                    ];
                    document.startViewTransition(updateDOM);
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        updateDOM()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function doroute(params) {
        return _ref.apply(this, arguments);
    };
}();
window.addEventListener("popstate", function() {
    $86609435a27b9d1d$var$doroute(new URLSearchParams(location.search));
});

})();
//# sourceMappingURL=index.ede8e5d7.js.map
